// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCHKW6aNZqKKf1n3jipmJXmy3ym5AvaoaI",
  authDomain: "skript-tech.firebaseapp.com",
  projectId: "skript-tech",
  storageBucket: "skript-tech.firebasestorage.app",
  messagingSenderId: "244842798387",
  appId: "1:244842798387:web:b76fe9b349e35628c03246",
  measurementId: "G-CTKM2DVK66"
};

const app = initializeApp(firebaseConfig);

if (typeof window !== 'undefined' && 'measurementId' in firebaseConfig) {
  getAnalytics(app);
}

export const db = getFirestore(app);
export default app;
